import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import CourseCard from '../../components/common/CourseCard';
import SEO from '../../components/common/SEO';
import { supabase } from '../../config/supabase';

const Courses = () => {
	const { t } = useTranslation();
	const [courses, setCourses] = useState([]);

	useEffect(() => {
		const fetchCourses = async () => {
			const { data, error } = await supabase
				.from('courses')
				.select('*')
				.order('created_at');

			if (!error) setCourses(data);
		};

		fetchCourses();
	}, []);

	// const courses = [
	//   {
	//     id: 1,
	//     title: 'crash_course_archicad',
	//     description: 'archicad_course_description',
	//     category: 'architecture',
	//     duration: 'varies',
	//     language: 'arabic_german',
	//     instructor: 'Bashar Al Gafri',
	//     requirements: 'student_at_tu_bs, own_laptop'
	//   },
	//   {
	//     id: 2,
	//     title: 'job_application_course',
	//     description: 'job_application_description',
	//     category: 'general',
	//     duration: '3_hours',
	//     language: 'arabic_german',
	//     instructor: 'Dipl.-Ing. Taher Doufesh',
	//     link: '/courses/job-application'
	//   },
	//   {
	//     id: 3,
	//     title: 'c_programming',
	//     description: 'c_programming_description',
	//     category: 'it',
	//     duration: '5_sessions',
	//     language: 'arabic',
	//     instructor: 'Mohammad Hamad',
	//     requirements: 'own_laptop, interest_in_programming'
	//   },
	//   {
	//     id: 4,
	//     title: 'math_bootstrap',
	//     description: 'math_bootstrap_description',
	//     category: 'general',
	//     duration: '8_sessions',
	//     language: 'arabic',
	//     instructor: 'Dipl.-Ing. Wilbert Vogel',
	//   },
	//   {
	//     id: 5,
	//     title: 'job_interview_crash',
	//     description: 'job_interview_description',
	//     category: 'general',
	//     duration: '4_sessions',
	//     language: 'arabic',
	//     instructor: 'Mona Al-Masri',
	//   },
	//   {
	//     id: 6,
	//     title: 'microcontroller_technology',
	//     description: 'microcontroller_technology_description',
	//     category: 'electrical_engineering',
	//     duration: 'varies',
	//     language: 'arabic',
	//     instructor: 'Prof. Wael Adi',
	//   },
	//   {
	//     id: 7,
	//     title: 'arduino_platform',
	//     description: 'arduino_platform_description',
	//     category: 'electrical_engineering',
	//     duration: 'varies',
	//     language: 'arabic',
	//     instructor: 'Prof. Wael Adi',
	//   },
	//   {
	//     id: 8,
	//     title: 'academic_advice_support',
	//     description: 'academic_advice_support_description',
	//     category: 'general',
	//     duration: 'ongoing',
	//     language: 'arabic',
	//     instructor: 'Prof. Wael Adi, Saleh Mulhem',
	//     isService: true
	//   }
	// ];

	return (
		<div className="py-12 bg-gray-50">
			<SEO
				title={t('seo.coursesTitle')}
				description={t('seo.coursesDescription')}
			/>

			<div className="container mx-auto px-4">
				<div className="text-center mb-12">
					<h1 className="text-4xl font-bold text-gray-900 mb-4">
						{t('courses.title')}
					</h1>
					<p className="text-xl text-gray-600 max-w-3xl mx-auto">
						{t('courses.subtitle')}
					</p>
				</div>

				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
					{courses.map((course) => (
						<CourseCard
							key={course.id}
							title={t(`courses.${course.title_key}`)}
							description={t(`courses.${course.description_key}`)}
							category={t(`categories.${course.category_key}`)}
							duration={t(`duration.${course.duration_key}`)}
							language={t(`languages.${course.language_key}`)}
							instructor={course.instructor}
							requirements={
								course.requirements_key
									? t(`requirements.${course.requirements_key}`)
									: null
							}
							link={course.link}
							isService={course.is_service}
						/>
					))}
				</div>

				<div className="mt-12 text-center">
					<Link
						to="/contact"
						className="inline-block bg-primary-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-primary-700 transition-colors"
					>
						{t('courses.registerInterest')}
					</Link>
				</div>
			</div>
		</div>
	);
};

export default Courses;
